/**
 * Full-screen overlay shown on mobile phones in portrait orientation
 * when viewing shared review or team projects.
 * Uses CSS @media orientation + pointer queries — no JS polling.
 */

import { useTranslation } from 'react-i18next';
import styles from './PortraitBlocker.module.css';

export function PortraitBlocker() {
  const { t } = useTranslation('common');

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <svg className={styles.icon} width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="2" width="16" height="20" rx="2" />
          <line x1="12" y1="18" x2="12" y2="18.01" />
        </svg>
        <div className={styles.arrow}>&#x21BB;</div>
        <p className={styles.title}>{t('rotateToLandscape')}</p>
        <p className={styles.subtitle}>{t('landscapeOrientationHint')}</p>
      </div>
    </div>
  );
}
